import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: `${API_URL}/documents`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const documentCategoryService = {
  list: async () => (await api.get('/categories')).data,
  hierarchy: async () => (await api.get('/categories/hierarchy')).data,
  stats: async (id) => (await api.get(`/categories/${id}/statistics`)).data,
  get: async (id) => (await api.get(`/categories/${id}`)).data,
  create: async (data) => (await api.post('/categories', data)).data,
  update: async (id, data) => (await api.put(`/categories/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/categories/${id}`)).data,
};

export default documentCategoryService;



